import React from "react";

interface MissingComponentWarningProps {
    componentId: string | null
}

export const MissingComponentWarning = ({componentId}: MissingComponentWarningProps) => {
    const icon = <i className="pi pi-times" style={{color: "#f6e574", fontSize: "3rem"}}/>
    let errorMsg: string
    if (componentId != null) {
        errorMsg = `Invalid component configuration: component type [${componentId}] does not exit!`;
    } else {
        errorMsg = `Invalid component configuration: component type is missing!`;
    }

    return <h1 style={{display: "flex", alignItems: "center", justifyContent: "center"}}>{icon}{errorMsg}{icon}</h1>;
}